import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import styles from './base-volume-option.module.scss';

interface BaseVolumeOptionProps {
  className?: string;
  volume: number;
  onUpdateVolume(value: number, undoable: boolean): void;
  onMuteUnmute(): void;
}

export function BaseVolumeOption({className = '', ...props}: BaseVolumeOptionProps): ReactElement<any> {
  return (
    <ContextualMenuSliderOptions
      id="volume-controls"
      className={className}
      inputCounterClassName={styles.input}
      controlIcons={[props.volume === 0 ? 'icon-sound' : 'icon-sound-off']}
      overrideDefaultContols
      controlsDisabledStates={[false]}
      onClickControl={(): void => {
        props.onMuteUnmute();
      }}
      range={{
        min: 0,
        max: 1,
      }}
      transformDisplay={{
        min: 0,
        max: 100,
      }}
      step={1}
      value={props.volume}
      label={window.i18next.t('pmwjs_volume')}
      onChange={(val: number): void => {
        props.onUpdateVolume(val, false);
      }}
      onChangeEnded={(val: number): void => {
        props.onUpdateVolume(val, true);
      }}
    />
  );
}
